module.exports = __webpack_public_path__ + "img/shift-week-off-option.ad9f053f.png";